<template>
  <div class="about-wrapper">
    <section id="about">
      <h1>关于我们</h1>
      <div class="about-container">
        <div class="about-header">
          <h3>关键包装</h3>
          <div class="about-divider"></div>
          <p class="about-subtitle">专注食品与餐饮行业的包材定制服务</p>
        </div>
        <p class="about-intro">
          关键包装是一家专注于食品与餐饮行业的包材定制服务团队，提供纸杯、纸袋、纸盒及其他外带包装的设计、印刷与生产支持。我们希望通过更贴近品牌需求的包装方案，帮助客户在产品展示、品牌识别与日常使用上取得更好的平衡。
        </p>
        <p class="about-philosophy">
          我们服务的应用场景涵盖咖啡、饮品、烘焙、轻食、零售食品等领域。对我们而言，包装不仅是产品的承载工具，也是在消费者接触品牌时最直接的一部分。关键包装希望让每一份包装都兼具实用性、视觉表现与品牌价值。
        </p>
        
        <div class="culture-container">
          <h3>企业文化</h3>
          <div class="about-divider"></div>
          <p>在关键包装，我们坚持以创新、专注、公平、激情的精神驱动团队发展，始终以客户需求为核心，提供高质量的包装解决方案。</p>
          
          <div class="culture-grid">
            <div class="culture-item" v-for="(item, index) in cultureItems" :key="index">
              <img v-if="item.image" :src="item.image" class="item-image" :alt="item.title" />
              <div class="item-content">
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
                <p class="en-text">{{ item.enText }}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="services-container">
          <h3>产品与服务</h3>
          <div class="about-divider"></div>
          <p>我们提供食品与餐饮行业常用包材的定制服务，涵盖纸袋、纸盒、纸杯及其他配套包装，协助客户从品牌呈现、使用体验到实际落地取得更合适的平衡。</p>
          
          <div class="services-grid">
            <div class="service-item" v-for="(service, index) in serviceItems" :key="index">
              <img v-if="service.image" :src="service.image" class="item-image" :alt="service.title" />
              <div class="item-content">
                <h4>{{ service.title }}</h4>
                <p>{{ service.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="divider"></div>
  </div>
</template>

<script>
import { getWebsiteContent } from '@/api/websiteContent.js';

const defaultServices = [
  { title: '纸袋类', description: '为各类产品定制纸袋，除了提供基本的保护功能，还能提升品牌价值。', image: require('@/assets/images/service_products/paper_bag.jpg') },
  { title: '西点盒类', description: '西点盒不仅需要体现品牌价值，更要通过独特的设计吸引消费者的注意。', image: require('@/assets/images/service_products/cake_box.jpg') },
  { title: '纸杯类', description: '为每个品牌挑选合适的纸杯设计，兼顾美观与实用性。', image: require('@/assets/images/service_products/paper_cup.jpg') },
  { title: '其他产品', description: '除了纸袋、纸杯和西点盒，我们还提供外带包装、快递盒等定制服务，帮助品牌提升市场知名度。', image: require('@/assets/images/service_products/other_products.jpg') }
];

export default {
  name: 'AboutView',
  data() {
    return {
      cultureItems: [],
      serviceItems: [...defaultServices]
    };
  },
  mounted() {
    getWebsiteContent()
      .then((data) => {
        if (Array.isArray(data.culture_cards) && data.culture_cards.length > 0) {
          this.cultureItems = data.culture_cards.map((c) => ({
            title: c.title_zh || '',
            description: c.description_zh || '',
            enText: c.description_en || '',
            image: c.image_url || ''
          }));
          console.log('[AboutView] 企业文化卡片已从后端加载', this.cultureItems.length, '项');
        } else {
          console.log('[AboutView] 未获取到 culture_cards，企业文化区块不显示卡片');
        }
        if (Array.isArray(data.service_cards) && data.service_cards.length > 0) {
          this.serviceItems = data.service_cards.map((s) => ({
            title: s.title || '',
            description: s.description || '',
            image: s.image_url || ''
          }));
        }
      })
      .catch((err) => {
        console.warn('[AboutView] 获取官网内容失败，企业文化区块不显示卡片', err);
      });
  }
};
</script>

<style scoped>
.about-wrapper {
  width: 100%;
  padding-top: 0;
}

#about {
  min-height: auto;
  padding: 20px 0 60px 0; /* 进一步减小上方留白，内容更靠上 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

#about h1 {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: white;
}

.divider {
  width: 80%;
  max-width: 1200px;
  height: 2px;
  background: #e50914;
  margin: 0 auto;
}

/* 关于我们部分样式 */
.about-container {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  color: #f5f5f5;
}

.about-header {
  margin-bottom: 30px;
  text-align: center;
}

.about-header h3, .culture-container h3, .services-container h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: white;
}

.about-divider {
  width: 60px;
  height: 3px;
  background: #e50914;
  margin: 15px auto;
}

.about-subtitle {
  font-size: 1.25rem;
  color: white;
  margin: 0 0 20px 0;
  text-align: center;
  line-height: 1.5;
}

.about-intro, .about-philosophy {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 30px;
  text-align: left;
}

.culture-container, .services-container {
  margin-top: 60px;
  text-align: center;
}

.culture-grid, .services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.culture-item, .service-item {
  background: #222;
  padding: 30px;
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.culture-item:hover, .service-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(229, 9, 20, 0.6), 0 0 30px rgba(229, 9, 20, 0.4);
}

/* 修改图片样式为预设图片 */
.item-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 30px;
  display: block;
  margin: 0 auto 30px;
}

/* 调整文字区域，使其下移 */
.item-content {
  margin-top: 20px;
}

/* 调整企业文化图片尺寸 - 放大 */
.culture-item .item-image {
  width: 250px;
  height: 250px;
  margin-bottom: 25px;
}

/* 调整产品与服务图片尺寸 - 更合适的宽度 */
.service-item .item-image {
  width: 220px;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* 调整服务项目卡片样式 */
.service-item {
  padding: 20px 15px;
  background: #222;
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  width: 220px;
  margin: 0 auto;
}

/* 调整服务容器整体居中 */
.services-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 40px auto;
}

/* 确保在小屏幕上也能正确居中 */
@media (max-width: 992px) {
  .services-grid {
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
  }
  
  .service-item {
    margin: 0 15px 30px;
    width: calc(50% - 60px);
    min-width: 200px;
  }
}

/* 改进服务项目标题样式 - 与整体设计更协调 */
.service-item h4 {
  background: #e50914;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  display: inline-block;
  margin: 0 auto 15px;
  font-size: 1.1rem;
  font-weight: 500;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
}

/* 调整服务项目描述文字 */
.service-item p {
  color: #ddd;
  line-height: 1.5;
  font-size: 0.9rem;
}

/* 调整服务网格布局为居中显示 */
.services-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 30px auto;
  width: 100%;
  max-width: 1200px;
  flex-wrap: nowrap;
}

/* 添加卡片悬停效果 */
.service-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 20px rgba(229, 9, 20, 0.15);
}

.service-item:hover h4 {
  background: #ff1a25;
}

/* 调整企业文化标题字体大小 */
.culture-item h4 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: white;
  font-weight: 600;
}

/* 添加英文翻译样式 */
.culture-item .en-text {
  color: #999;
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 5px;
  margin-bottom: 15px;
}
</style> 